import {
  ADD_ITEM,
  ADD_ITEM_FAILURE,
  ADD_ITEM_SUCCESS,
  DELETE_ITEM,
  DELETE_ITEM_FAILURE,
  DELETE_ITEM_SUCCESS,
  EDIT_ITEM,
  EDIT_ITEM_FAILURE,
  EDIT_ITEM_SUCCESS,
  GET_ITEMS_COUNTING_REPORT,
  GET_ITEMS_COUNTING_REPORT_FAILURE,
  GET_ITEMS_COUNTING_REPORT_SUCCESS,
  GET_ITEMS_LIST,
  GET_ITEMS_LIST_FAILURE,
  GET_ITEMS_LIST_SUCCESS,
  GET_ITEMS_TRANSACTIONS_LIST,
  GET_ITEMS_TRANSACTIONS_LIST_FAILURE,
  GET_ITEMS_TRANSACTIONS_LIST_SUCCESS,
  GET_ITEM_COUNTING_DASHBOARD_DATA,
  GET_ITEM_COUNTING_DASHBOARD_DATA_FAILURE,
  GET_ITEM_COUNTING_DASHBOARD_DATA_SUCCESS,
  GET_ITEM_TRANSACTIONS_DASHBOARD_DATA,
  GET_ITEM_TRANSACTIONS_DASHBOARD_DATA_FAILURE,
  GET_ITEM_TRANSACTIONS_DASHBOARD_DATA_SUCCESS,
  GET_TRANSFER_REPORT,
  GET_TRANSFER_REPORT_FAILURE,
  GET_TRANSFER_REPORT_SUCCESS,
} from '../../modules/constants';

// get items list
export const getItemsListRequest = (state, action) => {
  return {
    ...state,
    isLoading: true,
  };
};
export const getItemsListRequestSuccess = (state, action) => {
  const { payload: data } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      itemsList: data.data,
    };
  }
  return {
    ...state,
    isLoading: false,
    itemsList: [],
  };
};
export const getItemsListRequestFailure = (state, action) => {
  return {
    ...state,
    isLoading: false,
    itemsList: [],
  };
};

// add item
export const addItemRequest = (state, action) => {
  return {
    ...state,
    isCrudLoading: true,
  };
};

// add item success
export const addItemRequestSuccess = (state, action) => {
  return {
    ...state,
    itemsList: [...state.itemsList, action.payload],
    isCrudLoading: false,
  };
};

// add item failure
export const addItemRequestFailure = (state, action) => {
  return {
    ...state,
    isCrudLoading: false,
  };
};

// edit item
export const editItemRequest = (state, action) => {
  return {
    ...state,
    isCrudLoading: true,
  };
};

// edit item success
export const editItemRequestSuccess = (state, action) => {
  const updatedItems = state.itemsList.map(item =>
    item.id === action.payload.id ? { ...item, ...action.payload } : item,
  );
  return {
    ...state,
    isCrudLoading: false,
    itemsList: updatedItems,
  };
};

// edit item failure
export const editItemRequestFailure = (state, action) => {
  return {
    ...state,
    isCrudLoading: false,
  };
};

// delete item
export const deleteItemRequest = (state, action) => {
  return {
    ...state,
    isCrudLoading: true,
  };
};

// delete item success
export const deleteItemRequestSuccess = (state, action) => {
  const filteredItems = state.itemsList.filter(
    item => item.id !== action.payload,
  );
  return {
    ...state,
    itemsList: filteredItems,
    isCrudLoading: false,
  };
};

// delete item failure
export const deleteItemRequestFailure = (state, action) => {
  return {
    ...state,
    isCrudLoading: false,
  };
};

// get counting report
export const getItemCountingDashboardDataRequest = (state, action) => {
  return {
    ...state,
    isCountingDashboardDataLoading: true,
  };
};

export const getItemCountingDashboardDataRequestSuccess = (state, action) => {
  if (action.payload.status !== 200) {
    return {
      ...state,
      isCountingDashboardDataLoading: false,
      itemCountingDashboardData: null,
    };
  }
  const { data } = action.payload;
  return {
    ...state,
    isCountingDashboardDataLoading: false,
    itemCountingDashboardData: data,
  };
};

export const getItemCountingDashboardDataRequestFailure = (state, action) => {
  return {
    ...state,
    isCountingDashboardDataLoading: false,
    itemCountingDashboardData: null,
  };
};

// get transfer report
export const getTransferReportRequest = (state, action) => {
  return {
    ...state,
    isTransferReportLoading: true,
  };
};

export const getTransferReportRequestSuccess = (state, action) => {
  const { payload: data } = action;
  if (data.status === 200) {
    return {
      ...state,
      isTransferReportLoading: false,
      transferReport: data.data,
    };
  }
  return {
    ...state,
    isTransferReportLoading: false,
    transferReport: [],
  };
};

export const getTransferReportRequestFailure = (state, action) => {
  return {
    ...state,
    isTransferReportLoading: false,
    transferReport: [],
  };
};

// get items transactions list
export const getItemsTransactionsListRequest = (state, action) => ({
  ...state,
  isItemsTransactionsLoading: true,
});

export const getItemsTransactionsListRequestSuccess = (state, action) => {
  const { payload: data } = action;
  if (data.status === 200) {
    return {
      ...state,
      isItemsTransactionsLoading: false,
      itemsTransactionsList: data.data,
    };
  }
  return {
    ...state,
    isItemsTransactionsLoading: false,
    itemsTransactionsList: [],
  };
};

export const getItemsTransactionsListRequestFailure = (state, action) => ({
  ...state,
  isItemsTransactionsLoading: false,
  itemsTransactionsList: [],
});

// get items counting report
export const getItemsCountingReportRequest = (state, action) => ({
  ...state,
  isItemsCountingReportLoading: true,
});

export const getItemsCountingReportRequestSuccess = (state, action) => ({
  ...state,
  isItemsCountingReportLoading: false,
  itemsCountingReport: action.payload.data || [],
});

export const getItemsCountingReportRequestFailure = (state, action) => ({
  ...state,
  isItemsCountingReportLoading: false,
  itemsCountingReport: [],
});

// get item transactions dashboard data
export const getItemTransactionsDashboardDataRequest = (state, action) => {
  return {
    ...state,
    isItemTransactionsDashboardLoading: true,
  };
};

export const getItemTransactionsDashboardDataRequestSuccess = (
  state,
  action,
) => {
  const { payload: data } = action;
  if (data.status === 200) {
    return {
      ...state,
      isItemTransactionsDashboardLoading: false,
      itemTransactionsDashboardData: data.data,
    };
  }
  return {
    ...state,
    isItemTransactionsDashboardLoading: false,
    itemTransactionsDashboardData: null,
  };
};

export const getItemTransactionsDashboardDataRequestFailure = (
  state,
  action,
) => {
  return {
    ...state,
    isItemTransactionsDashboardLoading: false,
    itemTransactionsDashboardData: null,
  };
};

// Action Handlers
const ACTION_HANDLERS = {
  [GET_ITEMS_LIST]: getItemsListRequest,
  [GET_ITEMS_LIST_SUCCESS]: getItemsListRequestSuccess,
  [GET_ITEMS_LIST_FAILURE]: getItemsListRequestFailure,
  [ADD_ITEM]: addItemRequest,
  [ADD_ITEM_SUCCESS]: addItemRequestSuccess,
  [ADD_ITEM_FAILURE]: addItemRequestFailure,
  [EDIT_ITEM]: editItemRequest,
  [EDIT_ITEM_SUCCESS]: editItemRequestSuccess,
  [EDIT_ITEM_FAILURE]: editItemRequestFailure,
  [DELETE_ITEM]: deleteItemRequest,
  [DELETE_ITEM_SUCCESS]: deleteItemRequestSuccess,
  [DELETE_ITEM_FAILURE]: deleteItemRequestFailure,
  [GET_ITEM_COUNTING_DASHBOARD_DATA]: getItemCountingDashboardDataRequest,
  [GET_ITEM_COUNTING_DASHBOARD_DATA_SUCCESS]:
    getItemCountingDashboardDataRequestSuccess,
  [GET_ITEM_COUNTING_DASHBOARD_DATA_FAILURE]:
    getItemCountingDashboardDataRequestFailure,
  [GET_TRANSFER_REPORT]: getTransferReportRequest,
  [GET_TRANSFER_REPORT_SUCCESS]: getTransferReportRequestSuccess,
  [GET_TRANSFER_REPORT_FAILURE]: getTransferReportRequestFailure,
  [GET_ITEMS_TRANSACTIONS_LIST]: getItemsTransactionsListRequest,
  [GET_ITEMS_TRANSACTIONS_LIST_SUCCESS]: getItemsTransactionsListRequestSuccess,
  [GET_ITEMS_TRANSACTIONS_LIST_FAILURE]: getItemsTransactionsListRequestFailure,
  [GET_ITEMS_COUNTING_REPORT]: getItemsCountingReportRequest,
  [GET_ITEMS_COUNTING_REPORT_SUCCESS]: getItemsCountingReportRequestSuccess,
  [GET_ITEMS_COUNTING_REPORT_FAILURE]: getItemsCountingReportRequestFailure,
  [GET_ITEM_TRANSACTIONS_DASHBOARD_DATA]:
    getItemTransactionsDashboardDataRequest,
  [GET_ITEM_TRANSACTIONS_DASHBOARD_DATA_SUCCESS]:
    getItemTransactionsDashboardDataRequestSuccess,
  [GET_ITEM_TRANSACTIONS_DASHBOARD_DATA_FAILURE]:
    getItemTransactionsDashboardDataRequestFailure,
};

// default initial state
const initialState = {
  isLoading: false,
  itemsList: [],
  isCrudLoading: false,
  isCountingDashboardDataLoading: false,
  itemCountingDashboardData: null,
  isTransferReportLoading: false,
  transferReport: [],
  isItemsTransactionsLoading: false,
  itemsTransactionsList: [],
  isItemsCountingReportLoading: false,
  itemsCountingReport: [],
  isItemTransactionsDashboardLoading: false,
  itemTransactionsDashboardData: null,
};

export default function itemsReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
